// 问题一个设备有本地，一个没有，数组内容是否
// 本地存储
const Itemarr = [];
const storage = {
    set(name,value,time = 1){
        localStorage.setItem(name,JSON.stringify(value));
        time = new Date().getTime() + time * 60 * 60 * 1000; //小时
        if(!Itemarr.includes(name)){
            Itemarr.push(name);
            localStorage.setItem(name+'_time',time);
        }
    },

    get(name) {
        let time = localStorage.getItem(name + '_time');
        // 判断当前时间是否小于给定时间
        if(time != null || new Date().getTime() < time){
            // 离过期十分钟前刷新
            if(new Date().getTime() >= time - 10 * 60 * 1000){
                let newtime = new Date().getTime() + 1 * 60 * 60 * 1000;
                localStorage.setItem(name+'_time',newtime);
            }
            if(!Itemarr.includes(name)){
                Itemarr.push(name);
            }
            let value = JSON.parse(localStorage.getItem(name))
            return value;
        }else{
            storage.remove(name); //清除过期数据
            return false;
        }
    },

    remove(name,flag=true){
        if(name){
            localStorage.removeItem(name);
            localStorage.removeItem(name+'_time');
            Itemarr.splice(Itemarr.indexOf(name),1);
            return
        }
        if(flag){
            //清除过期数据
            Itemarr.forEach(element => {
                let eName = localStorage.getItem(element);
                let eTime = localStorage.getItem(element+'_time')
                if(eName == null || new Date().getTime() > eTime){
                    localStorage.removeItem(element);
                    localStorage.removeItem(element+'_time');
                    Itemarr.splice(Itemarr.indexOf(element),1);
                }
            });
        }else{
            localStorage.clear(); //关闭浏览器全部清除
            Itemarr = [];
        }
    }
}
export default storage;